module.exports = __webpack_public_path__ + "static/img/freepark.1720a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/freepark.png
// module id = vQSI
// module chunks = 1